import axios from 'axios';
//export const BASE_URL = 'https://localhost:7142'; //localhost
export const BASE_URL = 'https://navabharatapi.agsapplications.com'; //production server
//export const BASE_URL = 'http://192.168.1.16:5057'; //test1 server

export const axiosOpen = axios.create({
    baseURL: BASE_URL
});

export const axiosAuth = axios.create({
    baseURL: BASE_URL,
    headers: { ContentType: 'application/json' },
    withCredentials: true
});
